(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-icon-with-logo"] && !Shopify.designMode) return;
  try {
    
//   document.addEventListener('DOMContentLoaded', function () {
//   var first_slider = document.querySelector('.first_category-icons');
//   var first_items = first_slider?.querySelectorAll('.category-icons__item');
//   var isMobile = window.innerWidth <= 767;

//   if ((first_items && first_items.length > 5) || (isMobile && first_items && first_items.length > 0)) {
//     var first_flkty = new Flickity(first_slider, {
//        cellAlign: 'left',
//   contain: true,
//   pageDots: false,
//   wrapAround: true,
//   autoPlay: 3000,
//   groupCells: false, // Very important — do NOT group
//   prevNextButtons: false,
//   draggable: true,
//     });

//     function updateButtonState() {
//       const prevButton = first_slider.querySelector('.flickity-prev-next-button.previous');
//       const nextButton = first_slider.querySelector('.flickity-prev-next-button.next');

//       if (first_flkty.selectedIndex === 0) {
//         prevButton?.setAttribute('disabled', 'true');
//       } else {
//         prevButton?.removeAttribute('disabled');
//       }

//       if (first_flkty.selectedIndex === first_flkty.slides.length - 1) {
//         nextButton?.setAttribute('disabled', 'true');
//       } else {
//         nextButton?.removeAttribute('disabled');
//       }
//     }

//     first_flkty.on('select', updateButtonState);
//     updateButtonState(); // Call once initially
//   }



//     var slider = document.querySelector('.second_category-icons');
//   var items = slider?.querySelectorAll('.category-icons__item');
  

//   if ((items && items.length > 5) || (isMobile && items && items.length > 0)) {
//     var flkty = new Flickity(slider, {
//       cellAlign: 'left',
//   contain: true,
//   pageDots: false,
//   wrapAround: true,
//   autoPlay: 3000,
//   groupCells: false, // Very important — do NOT group
//   prevNextButtons: false,
//   draggable: true,
//     });

//     function updateButtonState() {
//       const prevButton = slider.querySelector('.flickity-prev-next-button.previous');
//       const nextButton = slider.querySelector('.flickity-prev-next-button.next');

//       if (flkty.selectedIndex === 0) {
//         prevButton?.setAttribute('disabled', 'true');
//       } else {
//         prevButton?.removeAttribute('disabled');
//       }

//       if (flkty.selectedIndex === flkty.slides.length - 1) {
//         nextButton?.setAttribute('disabled', 'true');
//       } else {
//         nextButton?.removeAttribute('disabled');
//       }
//     }

//     flkty.on('select', updateButtonState);
//     updateButtonState(); // Call once initially
//   }
    
// });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  var slider = document.querySelector('.category-icons');
  var items = slider?.querySelectorAll('.category-icons__item');
  var isMobile = window.innerWidth <= 767;

  if ((items && items.length > 8) || (isMobile && items && items.length > 0)) {
    var flkty = new Flickity(slider, {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      groupCells: false,
      wrapAround: false,
      prevNextButtons: true,
       autoPlay: true
    });

    function updateButtonState() {
      const prevButton = slider.querySelector('.flickity-prev-next-button.previous');
      const nextButton = slider.querySelector('.flickity-prev-next-button.next');

      if (flkty.selectedIndex === 0) {
        prevButton?.setAttribute('disabled', 'true');
      } else {
        prevButton?.removeAttribute('disabled');
      }

      if (flkty.selectedIndex === flkty.slides.length - 1) {
        nextButton?.setAttribute('disabled', 'true');
      } else {
        nextButton?.removeAttribute('disabled');
      }
    }

    flkty.on('select', updateButtonState);
    updateButtonState(); // Call once initially
  }
});


  } catch(e) { console.error(e); }
})();
})();
